import React, {
  useState,
  useRef,
  useCallback,
  useMemo,
  useEffect,
} from 'react';
import { Modal, Button, message, Tooltip, Radio, Dropdown } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import {
  FileType,
  FolderTypeEnum,
  HeadersType,
  PermissionEnum,
  SearchType,
  SelectType,
  ShareType,
  TabKeyType,
  UserType,
} from '../types';
import {
  JoyspacePermissionType,
  getJoySpaceReadOnlyPermission,
} from '../config/permissions.config';
import Tab from './components/Tab';
import { tab, tabAllList } from './components/Tab/config';
import { getTabList } from '../utils/tab';
import styles from './index.module.less';
import MemberSelect from '../MemberSelect';
import { SearchIcon } from '../assets/icons/svg';
import { SearchGlobal } from './components/SearchGlobal';
import { addShareUser, getShareUserNum, getUser } from '../api/user';
import { getWorkLineList } from '../api/ebook';

interface IProps {
  id: string; // pageId
  activeKey?: TabKeyType; // 默认显示的tab
  isModalVisible: boolean; // 控制分享弹窗打开
  type: FileType; // 文件夹 || 文档
  isExternalContacts: boolean; // 是否为外部联系人
  header?: HeadersType;
  title?: string; // modal标题
  // pageStore?: any;
  // getAtInfos?: any;
  // isAt?: boolean;
  permissions: PermissionEnum[]; // 权限
  permissionType: JoyspacePermissionType | any; // 你当前的权限
  modalType?: string; // modalType 只有分享来的才展示管理协作者
  folderType?: FolderTypeEnum; // 我的文件 || 共享文件
  onCancel: () => void;
  // selectList?: (SelectType | any)[];
  onOK?: (item: any) => void;
  openMemberModal?: () => void;
  // removeNode?: () => void;
  from?: string; // 来源
  events?: any; // 事件订阅
  isShowManageBtn?: boolean; // 是否显示管理协作者按钮
  isShowShareType?: boolean; // 是否显示右侧分享方式区域
  defaultShareType?: ShareType; // 默认分享方式
  isShowHeaderTip?: boolean; // 是否显示标题旁的问号
  isKnowledge?: boolean; // 是否为知识库
  headerTooltipText?: string; // 标题右侧问号tooltip文案
}

const parames: any = {
  id: '',
  dialogueMessage: ShareType.ShareMessage,
  type: FileType.Page,
  toGroups: [],
  toOrgs: [],
  toUsers: [],
  toEpssUsers: [],
  header: null,
};
export default function ShareSearchModal(props: IProps) {
  const {
    id = '',
    activeKey = TabKeyType.RecentlyContact,
    isModalVisible = false,
    title = '分享给',
    type = FileType.Page,
    // pageStore,
    // getAtInfos,
    permissionType,
    permissions,
    // isAt = false,
    modalType = 'share',
    folderType = FolderTypeEnum.SHARE,
    isExternalContacts = false,
    // removeNode,
    onCancel,
    // header,
    onOK,
    openMemberModal,
    events,
    isShowManageBtn = true,
    isShowShareType = true,
    defaultShareType = ShareType.ShareMessage,
    isShowHeaderTip = true,
    isKnowledge = false,
    headerTooltipText,
  } = props;
  // debugger;
  const [loading, setLoading] = useState<boolean>(false);
  const [tabLoading, setTabLoading] = useState<boolean>(false);
  const [ackey, setActiveKey] = useState<TabKeyType>(activeKey);
  const [keyWord, setKeyWord] = useState<string>('');
  const [deptId, setDeptId] = useState<string>('');
  const [selectList, setSelectList] = useState<SelectType[]>([]);
  const [shareType, setShareType] = useState<ShareType>(defaultShareType);
  const [count, setCount] = useState<Number>(0);
  const [visibleSerch, setVisibleSerchModal] = useState(false);
  const [placeholder, setPlaceholder] = useState('搜索联系人/部门/群组');
  const [hasWorkLine, setHasWorkLine] = useState<boolean>(false);

  const getUserNum = useCallback(async () => {
    try {
      const res: any = await getShareUserNum(id);
      setCount(res?.[0] || 0);
    } catch (error) {
      console.error(error);
    }
  }, [id]);

  const getWorkLine = useCallback(async () => {
    setTabLoading(true);
    const res: any = await getWorkLineList();
    console.log(
      res?.deptInfoList,
      'getWorkLineList',
      res?.deptInfoList ? res?.deptInfoList.length !== 0 : false
    );
    setHasWorkLine(res?.deptInfoList ? res?.deptInfoList.length !== 0 : false);
    setTabLoading(false);
  }, []);

  useEffect(() => {
    if (!isModalVisible) {
      return;
    }
    getUserNum();
    getWorkLine();
    setPlaceholder('搜索');
    if (!events?.listeners['joyspace:updata_number']) {
      events?.on('joyspace:updata_number', getUserNum);
    }
    console.log(events, 'events===>01');
    return () => {
      let key = events?.remove ? 'remove' : 'off';
      console.log(events, 'events===>02');
      if (events && events[key]) {
        events[key]('joyspace:updata_number', getUserNum);
      }
      console.log(events, 'events===>03');
    };
  }, [isModalVisible]);

  const openAddMembersModal = () => {
    openMemberModal?.();
  };
  // 渲染
  const UseRender = () => {
    return (
      <div className={styles['header-selected-count']}>
        <span>已选:</span> <span>{selectList.length || 0}</span>
      </div>
    );
  };
  // 底部
  const Footer = useCallback(() => {
    return (
      <div className={styles['joyspace-share-modal-footer']}>
        <div className={styles['joyspace-share-modal-footer_l']}>
          已有<span>{count}</span>
          {isKnowledge ? '成员' : '协作者'}
          {isShowManageBtn &&
            modalType === 'share' &&
            !(
              location.href.includes('myspace') && type === FileType.Folder
            ) && (
              <Button
                type="text"
                onClick={openAddMembersModal}
                disabled={!permissions?.includes(PermissionEnum.SHARE_MANAGE)}
              >
                管理协作者
              </Button>
            )}
        </div>
        <div className={styles['joyspace-share-modal-footer_r']}>
          <Button
            onClick={() => {
              setSelectList([]);
              setKeyWord('');
              onCancel();
              setVisibleSerchModal(false);
            }}
          >
            取消
          </Button>
          <Button
            type="primary"
            disabled={!selectList.length}
            loading={loading}
            onClick={() => {
              // if (shareType === ShareType.ShareAI) {
              //     analysisLog("xtbg_joyspace_share", "byAI", from, type.toString(), id);
              // }
              if (shareType === ShareType.ShareMessage) {
                const isDept = selectList.some(
                  (item: any) =>
                    item.type === TabKeyType.Department ||
                    item.type === TabKeyType.WorkLine
                );
                // eslint-disable-next-line no-debugger
                // debugger;
                if (isDept) {
                  message.error(
                    '不支持通过会话分享给部门，您可选择通过AI助手分享给部门'
                  );
                  setLoading(false);
                  return;
                }
              }
              onFinish();
            }}
          >
            确定
          </Button>
        </div>
      </div>
    );
  }, [count, selectList, modalType, type, permissions, shareType, loading]);

  const onFinish = async () => {
    setLoading(true);
    parames.id = id;
    parames.dialogueMessage = shareType;
    parames.type = type;
    parames.toEpssUsers = [];
    parames.toUsers = [];
    parames.toOrgs = [];
    parames.toGroups = [];
    console.log('selectList111', selectList);
    for (let item of selectList) {
      if (
        item.type === TabKeyType.Contact ||
        item.type === TabKeyType.RecentlyContact
      ) {
        // const [userId, teamId] = item.id.split(':gwork:');
        parames.toEpssUsers.push({
          // id: item.id,
          permission_type: item.permissionType,
          userId: (item as any).userId,
          teamId: (item as any).teamId || (item as any).tenantId,
        });
      } else if (
        item.type === TabKeyType.Department ||
        item.type === TabKeyType.WorkLine
      ) {
        parames.toOrgs.push({
          code: item.id,
          permission_type: item.permissionType,
        });
      } else if (item.type === TabKeyType.Groups) {
        parames.toGroups.push({
          gid: item.id,
          permission_type: item.permissionType,
        });
      }
    }
    addShareUser(parames)
      .then((res: any) => {
        if (!res) {
          return;
        }
        message.success(
          folderType === FolderTypeEnum.MY && type === FileType.Folder
            ? '分享成功，该文件夹将移动到【共享文件】'
            : '分享成功'
        );
        setSelectList([]);
        setKeyWord('');
        onCancel();
        setVisibleSerchModal(false);
        setShareType(defaultShareType);
      })
      .finally(() => {
        setLoading(false);
        // setKeyWord('');
        onOK?.({ data: selectList, shareType: parames.dialogueMessage });
      });
  };
  const selectDepartmentTab = useCallback(
    (key, deptId = '') => {
      setActiveKey(key);
      setDeptId(deptId);
    },
    [activeKey]
  );
  const childRef = useRef<any>();
  // 点击复选框
  const onChangeCheck = useCallback(
    (item: any) => {
      if (!item) {
        return;
      }
      const tmpList = selectList.concat();
      if (item.checked) {
        item.permissionType = getJoySpaceReadOnlyPermission();
        tmpList.push(item);
      } else {
        const index = tmpList.findIndex((_item: any) => _item.id === item.id);
        index !== -1 && tmpList.splice(index, 1);
      }
      childRef.current && childRef.current.addUserAll(tmpList);
      setSelectList(tmpList);
    },
    [selectList]
  );
  const onCheckAllChange = useCallback(
    (data: any[] = [], checkAll = false) => {
      let newList: any[] = [];
      if (checkAll) {
        const tmpList = data.concat(selectList);
        for (let item of tmpList) {
          const has = newList.some((_item: any) => _item.id === item.id);
          if (!has) {
            item.checked = true;
            item.permissionType = getJoySpaceReadOnlyPermission();
            newList.push(item);
          }
        }
      } else {
        newList = selectList.concat();
        for (let item of data) {
          const index = newList.findIndex((_item: any) => _item.id === item.id);
          if (index !== -1) {
            newList.splice(index, 1);
          }
        }
      }
      childRef.current && childRef.current.addUserAll(newList);
      setSelectList(newList);
    },
    [selectList]
  );
  const removeUserPermission = useCallback(
    item => {
      const _list = [...selectList];
      const index = _list.findIndex(_item => _item.id === item.id);
      if (index !== -1) {
        _list.splice(index, 1);
        setSelectList(_list);
      }
    },
    [selectList]
  );
  const onChangeShare = useCallback((e: any) => {
    setShareType(e.target.value);
  }, []);
  const getMembersTitle = () => {
    return (
      <div className={styles['joyspace-share-header']}>
        {title}
        {isShowHeaderTip && (
          <React.Fragment>
            <Tooltip
              placement="top"
              title={
                '如果被分享人的已有权限高于本次分享设置的权限，则该用户的权限不会被改变。如需变更用户的权限，请在“协作者管理”中设置。'
              }
              overlayClassName={styles['joyspace-share-tooltip']}
            >
              <QuestionCircleOutlined />
            </Tooltip>
          </React.Fragment>
        )}
      </div>
    );
  };

  return (
    <Modal
      width={800}
      title={getMembersTitle()}
      destroyOnClose={true}
      visible={isModalVisible}
      className={styles['joyspace-share-modal']}
      onCancel={() => {
        setActiveKey(TabKeyType.RecentlyContact);
        setSelectList([]);
        onCancel();
        setKeyWord('');
        setVisibleSerchModal(false);
      }}
      footer={Footer()}
    >
      <div className={styles['joyspace-share-main']}>
        <div className={styles['joyspace-share-main-l']}>
          <SearchGlobal
            placeholder={placeholder}
            visibleSerch={visibleSerch}
            isExternalContacts={isExternalContacts}
            tab={getTabList({
              isSearch: true,
              isExternalContacts,
              hasWorkLine,
            })}
            isSelectUser={false}
            id={id}
            selectList={selectList}
            onChangeKeyWord={(keyWord: string) => {
              setKeyWord(keyWord || '');
            }}
            isHasDep={!isExternalContacts}
            isHasWorkLine={hasWorkLine}
            onChangeCheck={onChangeCheck}
            onCheckAllChange={onCheckAllChange}
            onvisibleSerch={() => {
              setVisibleSerchModal(false);
            }}
            selectDepartmentTab={selectDepartmentTab}
          ></SearchGlobal>
          <div className={styles['joyspace-share-search-container']}>
            <div
              className={styles['joyspace-share-search-container_input']}
              onClick={() => {
                setVisibleSerchModal(true);
              }}
            >
              <SearchIcon></SearchIcon>
              <span>{placeholder}</span>
            </div>
          </div>
          <Tab
            pageId={id}
            tabStyle={{ height: 'auto' }}
            tab={getTabList({
              isSearch: false,
              isExternalContacts,
              hasWorkLine,
            })}
            isExternalContacts={isExternalContacts}
            acKey={ackey}
            selectList={selectList}
            // keyWord={keyWord}
            isSendCheckAll={true}
            deptId={deptId}
            onChangeCheck={(item: any) => {
              onChangeCheck(item);
            }}
            _onCheckAllChange={onCheckAllChange}
            selectDepartmentTab={selectDepartmentTab}
            tabLoading={tabLoading}
          />
        </div>
        <div className={styles['joyspace-share-main-r']}>
          <MemberSelect
            ref={childRef}
            id={id}
            type={type}
            permission={permissionType}
            removeUserPermission={removeUserPermission}
            render={() => <UseRender />}
            getData={list => {
              setSelectList(list);
            }}
            onChangeShare={onChangeShare}
            isShowShareType={isShowShareType}
            isKnowledge={isKnowledge}
          />
        </div>
      </div>
    </Modal>
  );
}
